import AddPopularDestinationForm from 'app/form/AddPopularDestinationForm';
import React from 'react';

const AddPopularDestination = () => {
	return (
		<div>
			<AddPopularDestinationForm />
		</div>
	);
};

export default AddPopularDestination;
